import { render, staticRenderFns } from "./DateProfit.vue?vue&type=template&id=d0190f34&scoped=true&"
import script from "./DateProfit.vue?vue&type=script&lang=js&"
export * from "./DateProfit.vue?vue&type=script&lang=js&"
import style0 from "./DateProfit.vue?vue&type=style&index=0&id=d0190f34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0190f34",
  null
  
)

export default component.exports